import FileList from "../fileList/FileList";

function Calendars() {

    return (
        <div>
            <FileList path='/calendars/calendars.json' title='Календарь' />
        </div>
    )
}

export default Calendars;